import styled from "styled-components";
import { theme } from "../../../theme";

export const FlexProductList = styled.table`
  width: 100%;
  border: ${(props) => `1px solid ${props.theme.primaryColor}`};
  overflow: hidden;
  border-radius: 10px;
  height: 3rem;
  margin-bottom: 2rem;
  border-collapse: separate;
  border-spacing: 0;
  background: #f9fafd;
  float: left;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const IndividualList = styled.th`
  cursor: pointer;
  max-width: 50px;
  border-left: ${(props) => `0.3px solid ${props.theme.primaryColor}`};
  border-right: ${(props) => `0.5px solid ${props.theme.primaryColor}`};
  padding: 1.4rem 1rem;
  background: ${(props) => (props.bgColor ? props.bgColor : "transparent")};
`;

export const MessageDiv = styled.div`
  height: 50vh;
  margin-top: 1.5rem;
  margin-right: 4rem;
  background: rgba(201, 211, 231, 0.214);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
